<template>
  <span v-if="user">
    <v-avatar size="32px">
      <img :src="user.photoURL">
    </v-avatar>
    <span class="ml-1">
      {{ user.name }}
    </span>
  </span>
</template>

<script>
import {db} from "@/firebase/db.js"

export default {
  props: ['userId', 'userObj'], 
  data: () => ({
    user: null,
  }),
  methods: {
    bind: function () {
      if (this.userId) {
        this.$bind("user", db.collection("users").doc(this.userId))
      } else {
        this.$unbind("user")
        this.user = this.userObj
      }
    },
  },
  watch: {
    userId: function () {
      this.bind()
    },
    userObj: function () {
      this.bind()
    },
  },
  created() {
    this.bind()
  },
};
</script>

